import { LeadSource } from '../types'
import { supabase } from './supabaseClient'
import { sourcePatch } from './mappers'
import { getDb, refresh } from './store'

/** Fuentes de captación de cada organización (`lead_sources`, con RLS). */
export function listSources(organizationId: string): LeadSource[] {
  return getDb()
    .sources.filter((s) => s.organizationId === organizationId)
    .sort((a, b) => a.order - b.order)
}

/** Busca una fuente por su clave (la que se detecta automáticamente). */
export function findSource(
  organizationId: string,
  key?: string,
): LeadSource | undefined {
  if (!key) return undefined
  const normalized = key.toLowerCase()
  return getDb().sources.find(
    (s) => s.organizationId === organizationId && s.key === normalized,
  )
}

export async function createSource(
  organizationId: string,
  name: string,
  icon: string,
  color: string,
): Promise<void> {
  const { error } = await supabase.from('lead_sources').insert({
    organization_id: organizationId,
    name,
    icon,
    color,
    is_active: true,
  })
  if (error) throw new Error(error.message)
  await refresh()
}

export async function updateSource(
  sourceId: string,
  patch: Partial<LeadSource>,
): Promise<void> {
  const { error } = await supabase
    .from('lead_sources')
    .update(sourcePatch(patch))
    .eq('id', sourceId)
  if (error) throw new Error(error.message)
  await refresh()
}

export async function deleteSource(sourceId: string): Promise<void> {
  const { error } = await supabase.from('lead_sources').delete().eq('id', sourceId)
  if (error) throw new Error(error.message)
  await refresh()
}
